<template>
    <div>
        <a-row>
            <a-col :span="18" :offset="3">
                <!--<a-timeline mode="left">-->
                <!--<a-timeline-item>111</a-timeline-item>-->
                <!--<a-timeline-item>Solve initial network problems 2015-09-01</a-timeline-item>-->
                <!--<a-timeline-item>Technical testing 2015-09-01</a-timeline-item>-->
                <!--<a-timeline-item>Network problems being solved 2015-09-01</a-timeline-item>-->
                <!--</a-timeline>-->

                <Card>
                    <DescriptionList size="large" title="患者信息" style="margin-bottom: 32px;">
                        <Description term="姓名">{{patient.name}}</Description>
                        <Description term="身份证号">{{patient.id_code}}</Description>
                    </DescriptionList>

                    <DescriptionList size="large" title="" style="margin-bottom: 32px;">
                        <Description term="手机号">{{patient.phone}}</Description>
                    </DescriptionList>

                    <Divider style="margin-bottom: 32px;" />

                    <DescriptionList size="large" title="医生信息" style="margin-bottom: 32px;">
                        <Description term="姓名">{{doctor.name}}</Description>
                        <Description term="身份证号">{{doctor.id_code}}</Description>
                    </DescriptionList>
                    <DescriptionList size="large" title="" style="margin-bottom: 32px;">
                        <Description term="手机号">{{doctor.phone}}</Description>
                    </DescriptionList>
                    <Divider style="margin-bottom: 32px;" />

                    <DescriptionList size="large" title="项目信息" style="margin-bottom: 32px;">
                        <Description term="项目名称"></Description>{{project.item.name}}
                    </DescriptionList>

                    <Divider style="margin-bottom: 32px;" />
                    <DescriptionList size="large" title="签署信息" style="margin-bottom: 32px;">
                        <Description term="签署时间">{{old.update_time}}</Description>

                    </DescriptionList>

                    <DescriptionList size="large" title="" style="margin-bottom: 32px;">

                        <Description term="知情同意书">
                        </Description>
                        <a :href="informed_consent.url+'?random_code='+user.random_code" target="_blank" >{{informed_consent.name}}</a>

                    </DescriptionList>
                    <Divider style="margin-bottom: 32px;" />


                </Card>
            </a-col>
        </a-row>
    </div>


</template>

<script>
    import request from "../../utils/request";
    import Global from "../../global_variable";
    import DescriptionList from "../../components/DescriptionList";
    import { Divider, Card } from "ant-design-vue";
    import getCookie from "../../utils/cookie";
    const { Description } = DescriptionList;
    export default {
        components: {
            DescriptionList,
            Description,
            Divider,
            Card
        },
        data() {
            return {
                formLayout: "horizontal",
                form: this.$form.createForm(this),
                old: {},
                user:JSON.parse(localStorage.getItem('user')),
                project:{item:{}},
                project_version:{},
                informed_consent: {},
                patient:{},
                accept: Global.accept,
                //设置上传的请求头部，IE10 以上有效
                headers: {
                    authorization: "authorization-text"
                },
                //上传请求时是否携带 cookie
                withCredentials: true,
                fileList: [],
                annexs: [],
                closeList: []
            };
        },
        mounted() {
            this.getData();
        },
        computed: {
            formItemLayout() {
                const { formLayout } = this;
                return formLayout === "horizontal"
                    ? {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 14 }
                    }
                    : {};
            },
            buttonItemLayout() {
                const { formLayout } = this;
                return formLayout === "horizontal"
                    ? {
                        wrapperCol: { span: 14, offset: 4 }
                    }
                    : {};
            }
        },
        methods: {
            normFile(e) {
                console.log("Upload event:", e);
                if (Array.isArray(e)) {
                    return e;
                }
                return e && e.fileList;
            },
            getData() {
                // console.log("vue内部document.cookie",document)
                // console.log("获取的cookis，getCookie",getCookie('cookie'))
                request({
                    url: "/project_foot/detail",
                    method: "get",
                    params: {
                        project_foot_id:this.$route.query.the_id
                    }
                }).then(response => {
                    console.log("获取到的数据",response)
                    let data = response.data;
                    if (data.success) {
                        // this.form.resetFields();
                        this.old = data.data;
                        this.project=data.data.project;
                        this.doctor=data.data.doctor;
                        this.patient=data.data.user;
                        this.token=data.token;
                        this.informed_consent=data.data.informed_consent;
                    } else {
                        this.$message.error(data.msg);
                    }
                });
            },
            handleChange(info) {
                // this.fileList = [...info.fileList];
                console.log("info", info);
                if (info.file.status === "removed") {
                }
                if (info.file.status !== "uploading") {
                    console.log(info.file, info.fileList);
                }
                if (info.file.status === "done") {
                    this.$message.success(`${info.file.name} file uploaded successfully`);
                    console.log("完成", info.file, info.fileList);
                } else if (info.file.status === "error") {
                    this.$message.error(`${info.file.name} file upload failed.`);
                }
            },
            handleChange1({ fileList }) {
                console.log('handleChange1',fileList);
                if (fileList && fileList.length > 0) {
                    this.fileList = [fileList[fileList.length - 1]];
                }else{
                    this.fileList = [];
                }
            },
            // handleChange1(info) {
            //   // this.fileList = [...info.fileList];
            //   console.log("info", info);
            //   if (info.file.status === "removed") {
            //     this.fileList=[];
            //   }
            //   if (info.file.status !== "uploading") {
            //     console.log(info.file, info.fileList);
            //   }
            //   if (info.file.status === "done") {
            //     this.fileList=info.fileList;
            //     this.$message.success(`${info.file.name} file uploaded successfully`);
            //   } else if (info.file.status === "error") {
            //     this.$message.error(`${info.file.name} file upload failed.`);
            //   }
            // },

            handleCancel() {
                this.previewVisible = false;
            },
            handlePreview(file) {
                console.log("打开附件",file)
            },
            handleFormLayoutChange(e) {
                this.formLayout = e.target.value;
            },
            closeAnnex(i) {
                console.log("关闭嗯", i);
                this.closeList.push(i);
            },
            addAnnex() {
                this.count += 1;
            },
            handleSubmit() {
                this.form.validateFields((err, values) => {
                    console.log("第一步", values);
                    if (!err) {
                        for (let i = 1; i <= this.count; i++) {
                            console.log("看卡" + i, values);
                            if (this.closeList.indexOf(i) !== -1) {
                                values["title_" + i] = "";
                                values["introduce_" + i] = "";
                                values["annex_" + i] = "";
                            } else {
                                let annex = values["annex_" + i];
                                if (annex) {
                                    if (annex.fileList) {
                                        annex = annex.fileList;
                                    }
                                    values["annex_" + i] = annex.map(x => {
                                        console.log("内部x", x, x.response);
                                        if (x.response) {
                                            return x.response;
                                        }
                                        return x;
                                    });
                                } else {
                                    values["annex_" + i] = "";
                                }
                            }
                        }
                        if (!this.fileList || this.fileList.length < 1) {
                            this.$message.error("请输入知情同意书");
                            return;
                        }
                        values.informed_consent = this.fileList[0];
                        console.log(this.form);
                        console.log(values);
                        values["count"] = this.count;

                        request({
                            url: "/project/" + this.$route.query.the_id,
                            method: "PUT",
                            data: values
                        }).then(response => {
                            let data = response.data;
                            if (data.success) {
                                this.form.resetFields();
                                this.$message.success(data.msg);
                                this.$router.push({ path: "/project/all" });
                            } else {
                                this.$message.error(data.msg);
                            }
                            console.log(response);
                        });
                    }
                });
            }
        }
    };
</script>
